import R from 'app/assets/R'
import { ExportOutlined, LoadingOutlined } from '@ant-design/icons'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { useTranslation } from 'react-i18next'
import { ButtonAction } from 'app/components/header/components/HeaderPage/styles'
import { useState } from 'react'

const Export: React.FC<{
  onPressExport
}> = ({ onPressExport }) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  const handleExport = async () => {
    setLoading(true)
    await onPressExport()
    setLoading(false)
  }
  
  return (
    <BaseCol>
      <ButtonAction onClick={handleExport}>
        <BaseRow gutter={8}>
          <BaseCol>
            <ExportOutlined rev={undefined} />
          </BaseCol>
          <BaseCol>{t(R.strings.export_excel)}</BaseCol>
          <BaseCol>{loading && <LoadingOutlined rev={undefined} />}</BaseCol>
        </BaseRow>
      </ButtonAction>
    </BaseCol>
  )
}

export default Export
